import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { BaseService } from '../shared/services/base.service';
import { PriceParamProjeto } from '../models/price-param-projeto.model';
import { Page } from '../models/page.model';

@Injectable({ providedIn: 'root' })
export class PriceParamProjetoService extends BaseService<PriceParamProjeto> {
  constructor(protected injector: Injector) {
    super(`${environment.API_PRICE}/PriceParamProjeto`, injector);
  }

  getByEstimativa(estimativaId: number): Observable<Page<PriceParamProjeto>> {
    return this.http.get<Page<PriceParamProjeto>>(
      `${environment.API_PRICE}/PriceParamProjeto/${estimativaId}`
    );
  }

  updateWithUsuario(param: PriceParamProjeto, usuarioId: number): Observable<void> {
    const body = { ...param, usuarioId };

    return this.http.put<void>(
      `${environment.API_PRICE}/PriceParamProjeto/${param.id}`, body
    );
  }
}
